import imageProject from './img/project.jpg'
import imageContext from './img/kindle.jpg'
import imagePlan from './img/plan.png'
import imageInterview from './img/interview.jpg'
import imageProtocol from './img/protocol.png'
import imageSitemap from './img/QuologueSitemap-AmyC.png'
import imageMiro from './img/figma.png'
import imageUserFlow from './img/QuologueUserflow-AmyC.png'

import imageDesign1 from './img/design/loading.jpg'
import imageDesign2 from './img/design/welcome.jpg'
import imageDesign3 from './img/design/keywords.jpg'
import imageDesign4 from './img/design/historyview.png'
import imageDesign5 from './img/design/3devices-2-01.jpg'

const images = {

  singles: {
    imageProject:    { src: imageProject, alt: 'Quologue Design' },
    imageContext:    { src: imageContext, alt: 'Quologue Design' },
    imagePlan:       { src: imagePlan, alt: 'Quologue Design' },
    interview:       { src: imageInterview, alt: 'Quologue Use Scenario' },
    protocol:        { src: imageProtocol, alt: 'Quologue Use Scenario' },
    sitemap:         { src: imageSitemap, alt: 'Quologue Sitemap'},
    imageMiro:       { src: imageMiro, alt: 'Quologue Use Scenario' },
    userFlow:        { src: imageUserFlow, alt: 'Quologue Use Scenario' },
  },

  design: [
    { src: imageDesign5, alt: 'Quologue Use Scenario' },
    { src: imageDesign1, alt: 'Quologue Design' },
    { src: imageDesign2, alt: 'Quologue Design' },
    { src: imageDesign3, alt: 'Quologue Design' },
    { src: imageDesign4, alt: 'Quologue Use Scenario' },
  ],
};

export default images;